import { authService } from "@_services/auth.service";
import React, { useEffect, useState } from "react";
import "./SingleSignOn.css";
window.Buffer = window.Buffer || require("buffer").Buffer;

function SingleSignOnPage() {
  const [message, setMessage] = useState("Processing single sign on...");

  useEffect(() => {
    // get url data
    let url = window.location.href;
    let dValue = "";
    new URL(url).searchParams.forEach((value, key) => {
      if (key && key === "d") {
        dValue = value;
      }
    });

    if (dValue) {
      let dData = JSON.parse(Buffer.from(dValue, "base64"));

      if (!dData || (!dData.id && !dData.token && !dData.nextHopp)) {
        // invalid request
        return;
      }

      // do the sso login of backend
      authService
        .ssoLogin(dData.id, dData.token)

        .then((user) => {
          localStorage.clear();
          localStorage.setItem("user", JSON.stringify(user));
          if (localStorage.getItem("invalid"))
            localStorage.removeItem("invalid");

          // redirect to next hopp
          if (dData.nextHopp) {
            window.location.href = dData.nextHopp;
          } else {
            window.location.href = "/";
          }
        })
        .catch((error) => {
          // invalid request or user not found
          if (error && error === "Internal Server Error") {
            // in case of user not found simply go to next hopp
            showReasonAndRedirect(
              {},
              "Error processing single sign on. Redirecting to login",
            );
          } else if (error && error === "Not Found") {
            showReasonAndRedirect(
              dData,
              "SSO data not valid. Redirecting to login...",
            );
          } else if (error && error === "Login failed.") {
            showReasonAndRedirect(
              dData,
              "Your account is not active yet. Please contact your administrator. Redirecting...",
            );
          } else {
            showReasonAndRedirect(
              {},
              "Not authorized. Redirecting to login...",
            );
          }
        });
    } else {
      showReasonAndRedirect({}, "Link is invalid. Redirecting to login...");
    }
  }, []);

  return (
    <div className="sso">
      <div className="ssoFormContainer">
        <h1>{message}</h1>
      </div>
    </div>
  );

  function showReasonAndRedirect(dData, message) {
    if (dData.nextHopp) {
      window.location.href = dData.nextHopp;
    } else {
      window.setTimeout(() => {
        window.location.href = "/";
      }, 4000);
      setMessage(message);
    }
  }
}

export default SingleSignOnPage;
